import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a4a5692")

_pushScopeId("data-v-1a4a5692")
const _hoisted_1 = { class: "main-wrap px-16" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Top movers")
const _hoisted_3 = {
  class: "items-wrap d-f mb-12",
  style: {"font-weight":"400","height":"88px"}
}
const _hoisted_4 = { class: "df-middle mb-4" }
const _hoisted_5 = { class: "c-text f-md" }
const _hoisted_6 = {
  class: "f-nm c-text mb-4 f-medium",
  style: {"line-height":"20px"}
}
const _hoisted_7 = { class: "df-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_Swipe = _resolveComponent("Swipe")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_t, {
      as: "p",
      path: "market_42",
      class: "f-bold c-text f-nm pb-12 pt-20"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_Swipe, {
      list: _ctx.tops,
      dot: true,
      dotDark: "",
      style: {"height":"114px"}
    }, {
      default: _withId(({item: group}) => [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(group, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: item.id,
              class: [{ 'mr-8': index < group.length - 1 }, "flex-1 anchor"],
              onClick: ($event: any) => (_ctx.change(item.contract))
            }, [
              _createVNode(_component_RealTimeQuote, {
                symbol: { ...item, code: item.contract }
              }, {
                default: _withId(({price, mp, isRise}) => [
                  _createVNode("div", {
                    class: ["box df-col df-center pl-16 py-12", { 'mr-8': index + 1 < item.length }]
                  }, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("p", _hoisted_5, _toDisplayString(item.contract), 1)
                    ]),
                    _createVNode("div", _hoisted_6, _toDisplayString(price), 1),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("p", {
                        class: ["f-nm", { 'c-success': isRise, 'c-danger': !isRise }]
                      }, _toDisplayString(mp), 3),
                      _createVNode(_component_Icon, {
                        class: ["p-0 ml-4", { 'c-success': isRise, 'c-danger': !isRise }],
                        sm: "",
                        name: isRise ? 'up' : 'down'
                      }, null, 8, ["class", "name"])
                    ])
                  ], 2)
                ]),
                _: 2
              }, 1032, ["symbol"])
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["list"])
  ]))
})